
import { runInAction, makeAutoObservable } from "mobx";

import { BaseStore } from "stores/base_store";

import { api_post } from "api/utils";
import { api_get } from "api/utils";
import { FileType } from "./file_store";

export type EmailProps = {
    key: string;
    uuid: string;
    identity: string;
    associated_type: string;
    associated_uuid: string;
    to_email: string;
    from_email: string;
    subject: string;
    content: string;
    status: string;
    files: string[];

    date_created: string;
    date_updated: string;
    updateProps?: (attributes: EmailProps) => void;
};

export type EmailHistoryType = {
    key: string;
    uuid: string;
    email: string;
    addr: string;
    event: string;
    timestamp: number;
    date_created: string;
};

// Domain object Email
export class Email implements EmailProps {
    key = "";
    uuid = "";
    identity = "";
    associated_type = "";
    associated_uuid = "";
    to_email = "";
    from_email = "";
    subject = "";
    content = "";
    status = "";
    files = [];

    date_created = "";
    date_updated = "";

    constructor(attributes: EmailProps) {
        makeAutoObservable(this, {
            updateProps: false
        })
        if (attributes) {
            this.updateProps(attributes);
        }
    }

    updateProps(attributes: EmailProps) {
        runInAction(() => {
            Object.assign(this, attributes);
        });
    }
}


export class EmailStore extends BaseStore<EmailProps, Email> {

    async sendEmail(
        workKey: string,
        associated_type: string,
        associated_uuid: string,
        to_email: string,
        from_email: string,
        subject: string,
        content: string,
        files: FileType[] = []
    ) {

        const data = {
            identity: workKey,
            associated_type,
            associated_uuid,
            to_email,
            from_email,
            subject,
            content,
            files: files.map((file) => file.uuid).join(",")
        }

        return api_post('/email/send', data)
            .then((resp) => {
                if(resp.ok) {
                    return resp.json();
                }
                else {
                    return null;
                }
            });
    }


    async resendEmail(workKey: string, email: string) {
        const data = {
            identity: workKey,
            email
        }
        return api_post('/email/resend', data)
            .then((resp) => {
                if(resp.ok) {
                    return resp.json();
                }
                else {
                    return null;
                }
            });
    }

    async fetchList(workKey: string, associated_type: string, associated_uuid: string, cursor: string = "") {
        const params = { identity: workKey, associated_type, associated_uuid, cursor };
        return api_get('/email/list/by-association', params)
            .then(async (result) => {
                if(result.ok) {
                const resp = await result.json() ;
                this.receiveUpdate(resp.items);
                if (resp.cursor) {
                    this.fetchList(workKey, associated_type, associated_uuid, resp.cursor);
                }
                return resp.items;
                }
                else {
                    return null;
                }
            });
    }

    async fetchHistory(workKey: string, email: string, cursor: string = "") {
        const params = { identity: workKey, email, cursor };
        return api_get('/email/history', params)
            .then(async (result) => {
                if (result.ok) {
                    const resp = await result.json();
                    this.receiveUpdate(resp.items);
                    if (resp.cursor) {
                        this.fetchList(workKey, email, resp.cursor);
                    }
                    return resp.items;
                }
                else {
                    return null;
                }
            });
    }


    modelConstructor() {
        return Email;
    }

}
